module.exports = __webpack_public_path__ + "static/media/PastOrders.93289c0f.svg";